// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"style_titleContainer__JqS08","title":"style_title__zC03E"};